module.exports = __webpack_public_path__ + "img/ic-comment.7fea0471.svg";